// Pure logic, no DOM — kept dependency-free (unlike main.js, which pulls in
// intl-tel-input's CSS) so it can run under `node --test`.
//
// Landing pages have an identical copy of this logic at
// app/assets/javascripts/global/dynamic-require-intl-tel-input.coffee.erb —
// keep both in sync.

const regionFromLocale = (locale, { maximize } = {}) => {
  try {
    const intlLocale = new Intl.Locale(locale)
    // Intl.Locale.region correctly extracts the region even when a script
    // subtag is present (e.g. "zh-Hant-TW" -> "TW"), unlike splitting on "-".
    const region = maximize ? intlLocale.maximize().region : intlLocale.region
    return region && /^[A-Za-z]{2}$/.test(region) ? region.toLowerCase() : null
  } catch {
    // Malformed locale tag — skip it.
    return null
  }
}

// Best-effort default country from the browser's locale (e.g. "es-ES" -> "es").
// Client-side, so it's cache-safe (unlike a server-rendered GeoIP value on a
// cacheable page) and still far better than intl-tel-input's alphabetical
// default (Afghanistan) when no country has been set.
export const countryFromBrowserLocale = () => {
  const locales =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language]

  // Prefer a region the browser actually reported (e.g. "es-ES" -> "es")
  // over a guessed one, checked across every preferred locale first.
  for (const locale of locales) {
    const region = regionFromLocale(locale)
    if (region) return region
  }

  // No preferred locale carried an explicit region — common for a browser/OS
  // language set to a bare "en" with no country. Fall back to CLDR's "most
  // likely" region for the language (Intl.Locale#maximize(), e.g. "en" ->
  // "US", "pt" -> "BR") rather than leaving intl-tel-input's own alphabetical
  // default (Afghanistan) to apply.
  for (const locale of locales) {
    const region = regionFromLocale(locale, { maximize: true })
    if (region) return region
  }

  return null
}
